var map = {
	"./ajax/popup-modules/give-rating/give-rating.js": 2620,
	"./ajax/popup-modules/popup.js": 7250,
	"./ajax/popup-modules/popups.js": 236,
	"./alpha-sorting/alpha-sorting.js": 6419,
	"./benefits-hover/benefits-hover.js": 5245,
	"./breadcrumbs/breadcrumbs.js": 7004,
	"./card-actions/card-actions.js": 2872,
	"./card-hover-slider/card-hover-slider.js": 7761,
	"./card-info-labels/card-info-labels.js": 3250,
	"./card-labels/card-labels.js": 3101,
	"./cards/catalog-card/catalog-card.js": 3722,
	"./cart-button/cart-button.js": 1925,
	"./cookie/cookie.js": 8862,
	"./file-input/file-input.js": 4848,
	"./footer-menu/footer-menu.js": 6567,
	"./form-blocks/checkbox/checkbox.js": 2390,
	"./form-blocks/radio/radio.js": 4949,
	"./payment-labels/payment-labels.js": 4476,
	"./reviews-selection/reviews-selection.js": 8085,
	"./sections/accordions/accordions.js": 540,
	"./sections/articles-other/articles-other.js": 9521,
	"./sections/articles-slider/articles-slider.js": 9221,
	"./sections/banner/banner.js": 7409,
	"./sections/benefits-slider/benefits-slider.js": 4624,
	"./sections/benefits/benefits.js": 4833,
	"./sections/cart-form/cart-form.js": 6828,
	"./sections/catalog-controls/catalog-controls.js": 5954,
	"./sections/catalog-controls/elems/change-layout/change-layout.js": 8877,
	"./sections/catalog-top/catalog-top.js": 8924,
	"./sections/characteristics/characteristics.js": 2963,
	"./sections/characteristics/elems/characteristics-block/characteristics-block.js": 7442,
	"./sections/comparison/compare-table/compare-table-block/compare-table-block.js": 1348,
	"./sections/comparison/compare-table/compare-table.js": 9852,
	"./sections/comparison/comparison.js": 4133,
	"./sections/comparison/fixed-header/fixed-header.js": 7057,
	"./sections/comparison/js/sliders-options.js": 3847,
	"./sections/comparison/js/slides-counter.js": 7271,
	"./sections/filter/blocks/filter-colors/filter-colors.js": 443,
	"./sections/filter/filter.js": 5149,
	"./sections/header/blocks/contact-info/contact-info.js": 8982,
	"./sections/header/blocks/dropdown-menu/dropdown-menu.js": 3761,
	"./sections/header/blocks/dropdown-menu/js/dropdown-menu-core.js": 3621,
	"./sections/header/blocks/dropdown-menu/js/switchable-menu.js": 8704,
	"./sections/header/blocks/header-search/header-search.js": 9409,
	"./sections/header/header.js": 6256,
	"./sections/header/js/header-hamburger.js": 5952,
	"./sections/info-labels/info-labels.js": 173,
	"./sections/instructions/instructions.js": 5267,
	"./sections/mentioned-products/mentioned-products.js": 9968,
	"./sections/new-products/new-products.js": 7831,
	"./sections/popular-brands/popular-brands.js": 3394,
	"./sections/product-page-card/blocks/card-info/elems/product-card-parameters/product-card-parameters.js": 2792,
	"./sections/product-page-card/elems/product-card-features/product-card-features.js": 3058,
	"./sections/product-page-card/elems/product-card-gifts/product-card-gifts.js": 976,
	"./sections/product-page-card/product-page-card.js": 3310,
	"./sections/questions-slider/questions-slider.js": 8227,
	"./sections/resently-viewed/resently-viewed.js": 2345,
	"./sections/reviews-sections/reviews-slider/reviews-slider.js": 8349,
	"./sections/reviews-sections/reviews/reviews.js": 7991,
	"./sections/selection/selection.js": 5499,
	"./sections/service/service.js": 440,
	"./sections/shopping-list/shopping-list.js": 3162,
	"./sections/sidebars/sidebar-advantages/sidebar-advantages.js": 1617,
	"./sections/sidebars/sidebar-contents/sidebar-contents.js": 9978,
	"./sections/slider-main/slider-main.js": 8711,
	"./sections/tabs-nav/tabs-nav.js": 4003,
	"./sections/text-inner/elems/text-inner-info/text-inner-info.js": 4257,
	"./sections/upsell/upsell.js": 2332,
	"./sidebar-connection/sidebar-connection.js": 1791,
	"./simple-popup/simple-popup.js": 4348,
	"./submenu/submenu.js": 2943,
	"./switcher/switcher.js": 8336,
	"./tags/tags.js": 814,
	"./up-button/up-button.js": 3758
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5775;